import React from "react";
import CustomButton from "Components/Commons/CustomButton/CustomButton";
import HeadingWithIcon from "Components/landing_page/HeadingWithIcon";
import { ImageWithTextContainer } from "./ImageWithText.style";
import { useNavigate } from "react-router-dom";

const ImageWithText = ({
    subheading = "Subjects",
    title = "Our",
    highlight = "Subjects",
    description = [], // array of paragraphs
    boldIndex = null, // index of paragraph to make bold
    buttonText = "Request a Demo",
    buttonLink = "/request-demo",
    image,
    reverse = false, // if true, image will be on right
}) => {

    const navigate = useNavigate();

    return (
        <ImageWithTextContainer className={`img_text_wrapper_main ${reverse ? "reverse" : ""}`}>
            <div className="imgwithtext-wrapper">
                <div className="mygrid-container">
                    <div className={`mygrid-row ${reverse ? "reverse-row" : ""}`}>
                        {/* Image Column */}
                        <div className="mygrid-col-lg-6 mygrid-col-md-12">
                            <div className="img_text_image">
                                {image && <img src={image} alt={highlight} />}
                            </div>
                        </div>

                        {/* Text Column */}
                        <div className="mygrid-col-lg-6 mygrid-col-md-12">
                            <div className="imgtext_content">
                                {subheading && <h5 className="subheading">{subheading}</h5>}
                                <HeadingWithIcon highlight={highlight}>{title}</HeadingWithIcon>

                                {description.map((para, index) => (
                                    <p key={index} style={index === boldIndex ? { fontWeight: "bold" } : {}}>
                                        {para}
                                    </p>
                                ))}

                                {buttonText && (
                                    <div className="intro_learnmore">
                                        <CustomButton
                                            onClick={() => navigate(buttonLink)}
                                            text={buttonText}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ImageWithTextContainer>
    );
};

export default ImageWithText;
